import {
  ADD_VEHICLE_MODEL,
  GET_VEHICLE_MODEL,
  GET_VEHICLE_MODEL_DETAILS,
  UPDATE_VEHICLE_MODEL,
  DELETE_VEHICLE_MODEL,
  UPDATE_VEHICLE_MODEL_STATUS,
  VEHICLE_MODEL_LIST
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const vehicleModelSlice = createCrudSlice({
  name: "vehicleModel",
  urls: {
    getList: GET_VEHICLE_MODEL,
    getDropdownList: VEHICLE_MODEL_LIST,
    add: ADD_VEHICLE_MODEL,
    update: UPDATE_VEHICLE_MODEL,
    delete: DELETE_VEHICLE_MODEL,
    updateStatus: UPDATE_VEHICLE_MODEL_STATUS,
    getDetails: GET_VEHICLE_MODEL_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
        makeId: "",
  },
});

// Export actions
export const { setFilter, resetFilters } = vehicleModelSlice.actions;

// Export thunks
export const {
  getList: getVehicleModelList,
  getDropdownList: getVehicleModelDropdownList,
  add: addVehicleModel,
  update: updateVehicleModel,
  delete: deleteVehicleModel,
  updateStatus: updateVehicleModelStatus,
  getDetails: getVehicleModelDetails,
  getRolesPermissions,
} = vehicleModelSlice.thunks;

// Export reducer
export default vehicleModelSlice.reducer;
